import * as React from 'react';

import { SpacesSiteUrls } from '../../app/spaces/SpacesSiteUrls';
import { Subspace, TabbedSpace } from '../../app/spaces/TabbedSpace';
import { PublishedConnectionSubspaceName } from '../../app/state/SpaceInfo';
import { Messages } from '../../codegen/Localize';
import { IPublishedConnectionInfo } from '../../ts/models/IPublishedConnectionInfo';
import { INamedItemInfo } from '../../ts/models/resourceInfoParts';
import { IPublishedConnectionActions } from '../../ts/ServerApi/types/IPublishedConnectionActions';
import { PublishedConnectionOverviewSubplace } from './PublishedConnectionOverviewSubplace';
import { PublishedConnectionSpaceHeader } from './PublishedConnectionSpaceHeader';

export type PublishedConnectionSpaceStateProps = {
  readonly urls: SpacesSiteUrls;
};

export type PublishedConnectionSpaceDispatchProps = {
  readonly addToFavorites: () => void;
  readonly removeFromFavorites: () => void;
};

export interface PublishedConnectionSpaceOwnProps {
  readonly subplaceName: string;

  // PublishedConnectionSpaceDataFetcher
  readonly publishedConnectionAllowedActions: IPublishedConnectionActions;
  readonly publishedConnectionInfo: IPublishedConnectionInfo;
  readonly projectHierarchy: INamedItemInfo[];
}

export type PublishedConnectionSpaceProps = PublishedConnectionSpaceStateProps & PublishedConnectionSpaceDispatchProps & PublishedConnectionSpaceOwnProps;

function overviewSubspace(publishedConnectionInfo: IPublishedConnectionInfo): Subspace {
  return {
    name: 'overview',
    tabLabel: Messages.overview(),
    renderContent: () => <PublishedConnectionOverviewSubplace publishedConnectionInfo={publishedConnectionInfo} />,
    shouldRenderTabContentCount: false
  };
}

export class PublishedConnectionSpace extends React.PureComponent<PublishedConnectionSpaceProps> {
  public urlFromSubspaceName = (subspaceName?: PublishedConnectionSubspaceName) => {
    switch (subspaceName) {
      case 'overview':
        return this.props.urls.publishedConnectionOverviewUrl(this.props.publishedConnectionInfo.id);
    }
    return this.props.urls.publishedConnectionUrl(this.props.publishedConnectionInfo.id);
  }

  public render() {
    const subspaces = [overviewSubspace(this.props.publishedConnectionInfo)];

    return (
      <TabbedSpace
        subspaces={subspaces}
        activeSubspaceName={this.props.subplaceName as PublishedConnectionSubspaceName}
        urlForSubspace={this.urlFromSubspaceName}
        mastheadElement={this.mastheadElement()}
        testIdPrefix={'publishedConnection'}
        spaceItemName={this.props.publishedConnectionInfo.name}
      />
    );
  }

  private mastheadElement(): React.ReactNode {
    // TODO - achristian - 2020-02-03 - TFSID: 1059566 - Fix this masthead.
    return (
      <PublishedConnectionSpaceHeader
        item={this.props.publishedConnectionInfo}
        availableActions={this.props.publishedConnectionAllowedActions}
        addToFavorites={this.props.addToFavorites}
        removeFromFavorites={this.props.removeFromFavorites}
        urls={this.props.urls}
      />
    );
  }
}
